import type { SxProps, Theme } from "@mui/material/styles";

/** Shared pill-style tab used by Assessment Center pages. */
export const pageSectionTabSx: SxProps<Theme> = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "20px",
  letterSpacing: 0,
  height: 54,
  minHeight: 54,
  textTransform: "none",
  borderRadius: "12px 12px 0 0",
  px: "16px",
  py: 0,
  alignItems: "flex-start",
  justifyContent: "center",
  backgroundColor: "#F2F2F2",
  color: "rgba(0, 0, 0, 0.85)",
  opacity: 1,
  whiteSpace: "normal",
  "& .MuiTab-label": {
    whiteSpace: "normal",
    width: "100%",
    alignItems: "flex-start",
  },
  "&.Mui-selected": {
    backgroundColor: "#fff",
    color: "rgba(0, 0, 0, 0.85)",
    opacity: 1,
  },
};

/** Shared Tabs container styling for section pages. */
export const pageSectionTabsSx: SxProps<Theme> = {
  minHeight: "auto",
  backgroundColor: "transparent",
  "& .MuiTabs-indicator": { display: "none" },
  "& .MuiTabs-flexContainer": {
    gap: "12px",
  },
};

/** Gray content area below the page header. */
export const pageSectionMainAreaSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
  px: 3,
  pb: "40px",
  display: "flex",
  flexDirection: "column",
  backgroundColor: "#F9FAFB",
};

/** Tab strip wrapper inside the main content area. */
export const pageSectionTabStripSx: SxProps<Theme> = {
  borderTopLeftRadius: "8px",
  borderTopRightRadius: "8px",
  pt: 2,
  pb: 0,
  backgroundColor: "#F9FAFB",
  flexShrink: 0,
};

/** Active tab panel wrapper. */
export const pageSectionTabPanelSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
};

export const pageSectionTitleSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: "24px",
  fontWeight: 700,
  color: "#0f172a",
  lineHeight: "32px",
  letterSpacing: 0,
};

export const pageSectionSubtitleSx: SxProps<Theme> = {
  maxWidth: 920,
  color: "#0D0D0D",
  fontSize: "0.875rem",
  lineHeight: 1.5,
};

/** White page header used by homepage-style entry pages. */
export const pageSectionHeaderSx: SxProps<Theme> = {
  py: "16px",
  px: "24px",
  position: "relative",
  zIndex: 2,
  flexShrink: 0,
  bgcolor: "#fff",
};

/** Standard small filter field sizing for section pages. */
export const pageSectionFilterFieldSx: SxProps<Theme> = {
  minWidth: 200,
  backgroundColor: "#fff",
};

/** Section table card container. */
export const pageSectionTableCardSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  border: "1px solid #e5e7eb",
  borderRadius: "8px",
  backgroundColor: "#fff",
};

/** Section table toolbar title. */
export const pageSectionTableTitleSx: SxProps<Theme> = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontWeight: 700,
  fontSize: "1rem",
  color: "#0f172a",
};
